/**
 * DashboardCard — a flexible surface with optional header (eyebrow + title + action)
 * and body. Used across dashboards to wrap charts, lists, panels.
 */
export default function DashboardCard({
  eyebrow,
  title,
  description,
  action,
  children,
  className = "",
  padded = true,
  accent = false,
  ...rest
}) {
  return (
    <div
      className={`rounded-xl border ${
        accent ? "bg-[#0A192F] text-white border-[#D4AF37]/30" : "bg-white border-slate-200"
      } ${className}`}
      data-testid={rest["data-testid"]}
    >
      {(eyebrow || title || action) && (
        <div className={`flex items-start justify-between gap-4 ${padded ? "p-6 pb-4" : ""} ${children ? "border-b border-slate-100" : ""} ${accent ? "border-white/10" : ""}`}>
          <div className="min-w-0">
            {eyebrow && (
              <p className={`text-[10px] uppercase tracking-[0.22em] font-bold ${accent ? "text-[#D4AF37]" : "text-[#1E3A8A]"}`}>
                {eyebrow}
              </p>
            )}
            {title && (
              <h3 className={`mt-1 text-lg font-semibold tracking-tight ${accent ? "text-white" : "text-[#0A192F]"}`}>
                {title}
              </h3>
            )}
            {description && (
              <p className={`mt-1 text-sm ${accent ? "text-slate-400" : "text-slate-500"}`}>
                {description}
              </p>
            )}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </div>
      )}
      <div className={padded ? "p-6 pt-5" : ""}>{children}</div>
    </div>
  );
}
